import React from 'react';
import { Heart, Quote } from 'lucide-react';

export const ShareStorySection = ({ storyForm, setStoryForm, storySubmitted, setStorySubmitted, storySubmitting, submitStory }) => (
  <section className="py-12 bg-[#F8F9FA]" data-testid="share-story-section">
    <div className="px-6 max-w-lg mx-auto">
      <div className="text-center mb-6">
        <Quote className="w-8 h-8 text-[#BA1826] mx-auto mb-3" />
        <h2 className="font-heading text-2xl font-bold text-[#0A0A0A] mb-2">
          Share Your Story
        </h2>
        <p className="text-sm text-[#4B5563]">
          If you've supported our mission, tell us why you chose to give and what it means to you.
          Approved stories will be featured on our site.
        </p>
      </div>

      {storySubmitted ? (
        <div className="bg-white border border-[#E5E7EB] rounded-lg p-6 text-center" data-testid="story-success">
          <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
            <Heart className="w-6 h-6 text-green-600" />
          </div>
          <h3 className="font-heading font-bold text-lg mb-2">Thank You!</h3>
          <p className="text-sm text-[#4B5563]">
            Your story has been submitted for review. Once approved, it will appear on our site.
          </p>
          <button onClick={() => setStorySubmitted(false)} className="mt-4 text-sm text-[#BA1826] hover:underline">
            Submit another story
          </button>
        </div>
      ) : (
        <div className="bg-white border border-[#E5E7EB] rounded-lg p-6">
          <div className="space-y-3 mb-4">
            <input
              type="text" placeholder="Your name" value={storyForm.name}
              onChange={(e) => setStoryForm({ ...storyForm, name: e.target.value })}
              className="w-full px-3 py-2 border border-[#E5E7EB] rounded-sm text-sm focus:border-[#BA1826] focus:outline-none"
              data-testid="story-name-input"
            />
            <select
              value={storyForm.country}
              onChange={(e) => setStoryForm({ ...storyForm, country: e.target.value })}
              className="w-full px-3 py-2 border border-[#E5E7EB] rounded-sm text-sm text-[#4B5563] focus:border-[#BA1826] focus:outline-none"
              data-testid="story-country-select"
            >
              <option value="">Which country did you support? (optional)</option>
              <option value="Haiti">Haiti</option>
              <option value="Colombia">Colombia</option>
              <option value="El Salvador">El Salvador</option>
              <option value="Ecuador">Ecuador</option>
              <option value="Jamaica">Jamaica</option>
              <option value="General Fund">General Fund</option>
            </select>
            <textarea
              placeholder="Why did you choose to give? What does it mean to you?"
              value={storyForm.quote}
              onChange={(e) => setStoryForm({ ...storyForm, quote: e.target.value })}
              rows={4} maxLength={1000}
              className="w-full px-3 py-2 border border-[#E5E7EB] rounded-sm text-sm focus:border-[#BA1826] focus:outline-none resize-none"
              data-testid="story-quote-input"
            />
          </div>
          <button
            onClick={submitStory}
            disabled={storySubmitting || !storyForm.name.trim() || !storyForm.quote.trim()}
            className="btn-primary w-full py-2.5 disabled:opacity-50"
            data-testid="submit-story-btn"
          >
            {storySubmitting ? 'Submitting...' : 'Submit Your Story'}
          </button>
          <p className="text-xs text-[#4B5563] text-center mt-3">Stories are reviewed before being published.</p>
        </div>
      )}
    </div>
  </section>
);
